import React from "react";
import GridLoader from "react-spinners/GridLoader";

const InnerLoading = () => {
  return <GridLoader color="var(--color-primary)" />;
};

export default InnerLoading;
